import React, { useState } from 'react';
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  Button,
  Flex,
  Box,
  Text,
  VStack,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { useAuth } from '../contexts/AuthContext';
import { getCilAdminUrl } from '../utils/adminUrl';
import FallingLeaves from './FallingLeaves';

const menuItemStyle = {
  variant: 'unstyled',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  bg: 'rgba(255,255,255,.06)',
  color: '#f4f5f7',
  border: '1px solid rgba(255,255,255,.08)',
  borderRadius: '14px',
  px: 5,
  fontWeight: '700',
  transition: 'all .2s',
  _hover: {
    bg: 'rgba(255,204,0,.14)',
    borderColor: '#ffcc00',
    color: '#ffcc00',
  },
};

const parentMenuButtonProps = {
  ...menuItemStyle,
  fontSize: 'lg',
  w: 'full',
  h: '52px',
  minH: '52px',
};

const subMenuButtonProps = {
  ...menuItemStyle,
  fontSize: 'sm',
  fontWeight: '600',
  borderRadius: '10px',
  w: 'full',
  h: '34px',
  minH: '34px',
  py: 0,
};

const MenuDrawer = ({ placement, isOpen, onModalClose, isAuthenticated }) => {
  const { userData } = useAuth();
  const [isSostieniOpen, setIsSostieniOpen] = useState(false);
  const showCilAdminLink =
    isAuthenticated &&
    (userData?.type === 'helper' || userData?.type === 'admin');

  return (
    <Drawer isOpen={isOpen} placement={placement} onClose={onModalClose}>
      <DrawerOverlay bg="rgba(14,16,19,.55)" />
      <DrawerContent
        zIndex={9000}
        py={4}
        color="#f4f5f7"
        bg="linear-gradient(180deg, rgba(30,33,39,.88) 0%, rgba(40,26,18,.9) 100%)"
        borderRight="1px solid rgba(255,255,255,.1)"
        borderLeft="1px solid rgba(255,255,255,.1)"
        boxShadow="0 0 60px rgba(0,0,0,.5)"
        overflow="hidden"
      >
        <FallingLeaves />
        <DrawerBody position="relative" zIndex={1}>
          <Flex
            direction="column"
            align="center"
            justify="space-between"
            height="100%"
          >
            <Flex
              direction="column"
              align="center"
              justify="flex-start"
              width="100%"
            >
              <Button
                as={Link}
                to="/"
                onClick={onModalClose}
                mb={2}
                {...parentMenuButtonProps}
              >
                Home
              </Button>
              <Button
                as={Link}
                to="/attivita"
                onClick={onModalClose}
                mb={2}
                {...parentMenuButtonProps}
              >
                Eventi
              </Button>
              <Box w="full" mb={2}>
                <Button
                  onClick={() => setIsSostieniOpen(!isSostieniOpen)}
                  rightIcon={<ChevronDownIcon />}
                  {...parentMenuButtonProps}
                >
                  Sostieni CIL
                </Button>
                {isSostieniOpen && (
                  <VStack
                    align="stretch"
                    spacing={2}
                    w="full"
                    mt={3}
                    pl={4}
                    aria-label="Sottomenu Sostieni CIL"
                  >
                    <Button
                      as={Link}
                      to="/sostienicil"
                      onClick={onModalClose}
                      {...subMenuButtonProps}
                    >
                      Dona ora
                    </Button>
                    <Button
                      as={Link}
                      to="/merch"
                      onClick={onModalClose}
                      {...subMenuButtonProps}
                    >
                      Merch
                    </Button>
                    <Button
                      as={Link}
                      to="/cil-5-per-1000"
                      onClick={onModalClose}
                      {...subMenuButtonProps}
                    >
                      Dona il 5x1000
                    </Button>
                  </VStack>
                )}
              </Box>
              <Button
                as={Link}
                to="/logbook"
                onClick={onModalClose}
                mb={2}
                {...parentMenuButtonProps}
              >
                Logbook
              </Button>

              {!isAuthenticated && (
                <Button
                  as={Link}
                  to="/tesseramento"
                  onClick={onModalClose}
                  mb={2}
                  {...parentMenuButtonProps}
                >
                  Tesseramento
                </Button>
              )}

              <Button
                as={Link}
                to="/contattaci"
                onClick={onModalClose}
                mb={2}
                {...parentMenuButtonProps}
              >
                Contattaci
              </Button>
            </Flex>

            <Box width="100%" mt={6}>
              {showCilAdminLink && (
                <Button
                  as="a"
                  href={getCilAdminUrl()}
                  target="_blank"
                  rel="noopener noreferrer"
                  mb={4}
                  {...parentMenuButtonProps}
                  justifyContent="center"
                  bg="#ffcc00"
                  color="#16181d"
                  borderColor="#ffcc00"
                  fontWeight="800"
                  _hover={{ bg: '#ffd83a' }}
                >
                  CIL ADMIN
                </Button>
              )}
              <Text
                fontSize="sm"
                fontWeight="800"
                textAlign="left"
                color="#ffcc00"
              >
                CIL - Creatività in libertà APS
              </Text>
              <Text fontSize="sm" textAlign="left" color="#c4c9d3">
                Via GB Buschetti 18
              </Text>
              <Text fontSize="sm" textAlign="left" color="#c4c9d3">
                10023 Chieri (TO)
              </Text>
              <Text fontSize="sm" textAlign="left" color="#c4c9d3">
                C.F.: 94090260012
              </Text>
              <Text
                as="a"
                href="mailto:info@cilassociazione.it"
                fontSize="sm"
                textAlign="left"
                textDecoration="underline"
                display="block"
                color="#c4c9d3"
                _hover={{ color: '#ffcc00' }}
              >
                info@cilassociazione.it
              </Text>
              <Text
                as="a"
                href="tel:+393534682493"
                fontSize="sm"
                textAlign="left"
                textDecoration="underline"
                display="block"
                color="#c4c9d3"
                _hover={{ color: '#ffcc00' }}
              >
                +39 353 468 2493
              </Text>
            </Box>
          </Flex>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default MenuDrawer;
